<template>
  <label class="search">
    <span class="sr-only">Search</span>
    <font-awesome-icon :icon="['fas', 'search']" class="icon alt" />
    <input
      v-model="input"
      type="text"
      :placeholder="hasSso ? 'Search name, email or SSO ID' : 'Search name or email'"
    />
  </label>
</template>

<script>
export default {
    name: 'OutcomesSearchBar',
    props: {
      hasSso: {
        type: Boolean,
        required: true,
      }
    },
    data() {
      return {
        input: '',
        searchTimeout: null
      }
    },
    watch: {
      input(value) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = null;
        }

      this.searchTimeout = setTimeout(() => {
        this.$emit('set-search', value)
      }, 500);
      }
    }
}

</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 0;
  width: 300px;
  max-width: 45%;
  min-width: 250px;
  background: #fff;
  height: 45px;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;

  .icon {
    font-size: 18px;
    margin-right: 8px;
  }

  input {
    border: 0;
    height: 80%;
    background: transparent;
    flex: 1;
    margin: 0;
    font-size: 14px;
  }

  select {
    width: 100%;
    height: 80%;
    background: transparent;
    border: none;
    font-weight: 500;
    font-size: 14px;
  }

  &:hover,
  &:focus {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}
</style>
